module.exports = __webpack_public_path__ + "static/fonts/Nunito-SemiBoldItalic.d98191e.woff2";